import { useState, useEffect } from "react";
import "./Header.css";

const PhoneIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.36 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.11 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z"/>
  </svg>
);

const MenuIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const CloseIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const NAV_LINKS = [
  { label: "Решения",  id: "solutions" },
  { label: "Услуги",   id: "services"  },
  { label: "СРО",      id: "sro"       },
  { label: "Проекты",  id: "gallery"   },
  { label: "FAQ",      id: "faq"       },
];

const MOBILE_NAV_LINKS = [
  ...NAV_LINKS,
  { label: "Контакты", id: "contact" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled,   setScrolled]   = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <header className={`header${scrolled ? " header--scrolled" : ""}`}>
      <div className="header__inner">

        {/* Логотип */}
        <div className="header__logo">
          <img src="Logo.png" alt="ITS" className="header__logo-img" />
          <span className="header__logo-divider" />
          <span className="header__logo-text">Айти Системы</span>
        </div>

        {/* Навигация — десктоп */}
        <nav className="header__nav">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="header__nav-btn"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* Правая часть */}
        <div className="header__right">
          <a href="tel:+78003012910" className="header__phone">
            <PhoneIcon />
            <span>8-800-300-29-10</span>
          </a>

          <button onClick={() => scrollTo("contact")} className="header__cta">
            Рассчитать проект
          </button>

          <button
            onClick={() => setMobileOpen((prev) => !prev)}
            className="header__burger"
            aria-label="Открыть меню"
          >
            {mobileOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Мобильное меню */}
      {mobileOpen && (
        <div className="header__mobile-menu">
          <div className="header__mobile-inner">
            {MOBILE_NAV_LINKS.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="header__mobile-btn"
              >
                {link.label}
              </button>
            ))}

            <div className="header__mobile-divider">
              <a href="tel:+78003002910" className="header__mobile-phone">
                <PhoneIcon />
                <span>8-800-300-29-10</span>
              </a>
            </div>

            <button onClick={() => scrollTo("contact")} className="header__mobile-cta">
              Рассчитать проект
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
